import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation} from "react-query";

export type GetTerminalListRequest = {
    merchantId: number | string;
  };
  
  export type GetTerminalListResponse = any;

  
  async function getTerminalList(data: GetTerminalListRequest): Promise<any> {
    try {
      const merchantId = data.merchantId;
      return (
        await axiosInstance.get(`/Terminal/List?merchantId=${merchantId}`)
      ).data;
    } catch (ex) {
      throw ((ex as AxiosError).response?.data as any).error;
    }
  }

  
  export function useGetTerminalList() {
    return useMutation<any, Error, GetTerminalListRequest>((variables) =>
      getTerminalList(variables)
    );
  }
  